import { t } from 'i18next'
import React from 'react'
import * as PosService from '../../Services/pos-service';
function PosRequestChangePersonalTable({ objectDto, setObjectDto }) {
    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped" id="personalTable">
                <thead>
                    <tr className="center">
                        <th className="u_t_no text-center description-small-customer" />
                        <th className="u_t_title text-center description-small-customer">{t('poschangefor')}</th>
                        <th className="u_t_title text-center description-small-customer">{t('fullname')}</th>
                        <th className="u_t_date text-center description-small-customer">{t('dob')}</th>
                        <th className="u_t_code text-center description-small-customer">{t('idnumber')}</th>
                        <th className="u_t_code text-center description-small-customer">{t('idtype')}</th>
                        <th className="u_t_date text-center description-small-customer">{t('iddate')} </th>
                        <th className="u_t_title text-center description-small-customer">{t('idplace')}</th>
                        <th className="u_t_code text-center description-small-customer">{t('gender')}</th>
                        <th className="u_t_code text-center description-small-customer" style={objectDto.saved === 1 ? { display: "none" } : {}}>{t('actionlabel')}</th>
                    </tr>
                </thead>
                <tbody id="changePersonalDetailtable">
                    {objectDto.changePersonalDetail !== undefined && objectDto.changePersonalDetail.length !== 0 ?
                        objectDto.changePersonalDetail.map((item) => {
                            return <tr>
                                <td className="text-center description-small-customer">{objectDto.changePersonalDetail.indexOf(item) + 1}</td>
                                <td className="text-left description-small-customer">{item.transactionTypeSub}</td>
                                <td className="text-left description-small-customer">{item.fullname}</td>
                                <td className="text-center description-small-customer">{item.dayOfBirth}</td>
                                <td className="text-left description-small-customer">{item.identityNumber}</td>
                                <td className="text-left description-small-customer">{item.identityType}</td>
                                <td className="text-center description-small-customer">{item.identityDate}</td>
                                <td className="text-left description-small-customer">{item.identityPlace}</td>
                                <td className="text-center description-small-customer">{item.gender}</td>
                                <td className="text-center description-small-customer" style={objectDto.saved === 1 ? { display: "none" } : {}}>
                                    <i className="fa fa-trash custom-icon delete btnDel description-medium-customer" title={t("icondelete")}
                                        onClick={() => PosService.RemovePersonal(objectDto, setObjectDto, item + 1)} />
                                </td>
                            </tr>
                        }) : ""}
                </tbody>
            </table>
        </div>
        // </div>
    )
}

export default PosRequestChangePersonalTable